import PropTypes from 'prop-types';
import React from 'react';

import {
  Components,
} from '@powdr/constants';

import { SlideText } from './slide-text';

export const FractionPagination = ({
  className = '',
  colorProfile,
  componentTheme,
  numItems,
  activeIndex,
}) => (
  <SlideText
    className={className}
    colorProfile={colorProfile}
    componentTheme={componentTheme}
  >
    {`${activeIndex + 1} / ${numItems}`}
  </SlideText>
);

FractionPagination.propTypes = {
  className: PropTypes.string,
  numItems: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  colorProfile: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  componentTheme: PropTypes.oneOf(Object.values(Components)),
};
